import { render, staticRenderFns } from "./QueryQbr.vue?vue&type=template&id=4c9540aa&scoped=true"
import script from "./QueryQbr.vue?vue&type=script&lang=js"
export * from "./QueryQbr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9540aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c9540aa')) {
      api.createRecord('4c9540aa', component.options)
    } else {
      api.reload('4c9540aa', component.options)
    }
    module.hot.accept("./QueryQbr.vue?vue&type=template&id=4c9540aa&scoped=true", function () {
      api.rerender('4c9540aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/QBR/QueryQbr.vue"
export default component.exports